import React, { Component } from "react";
import Cookies from "universal-cookie";
import { Buffer } from "buffer";
import MainLayout from "../../components/layouts/MainLayout";
import { withRouter } from "../../hoc/withRouter";
import withAuth from "../../hoc/withAuth";
import { Button, Col, Form, Input, Row, Modal, Select, Upload } from "antd";
import { SaveOutlined, UndoOutlined, UploadOutlined } from "@ant-design/icons";
import { DocumentHandoverStates } from "./types/DocumentHandoverTypes";
import { docUploadApiService } from "../../services/otodis/DocUploadApiService";

export interface DocumentHandoverProps {}

class DocumentHandover extends Component<DocumentHandoverProps & any, DocumentHandoverStates> {
  private readonly initState!: DocumentHandoverStates;
  private user = JSON.parse(Buffer.from(new Cookies().get("_u"), "base64").toString());
  private token = new Cookies().get("_t");

  constructor(props: (DocumentHandoverProps & any) | any) {
    super(props);

    const finalDealerCode = props.match.params.dealerCode.replace(/-/g, "#");

    this.initState = {
      processing: false,
      submitting: false,

      dealerCode: finalDealerCode,
      dealerSelected: [finalDealerCode],
      engineNumber: "",
      documentType: "",
      documentNumber: "",
      documentFile: "",
    };
    this.state = { ...this.initState };
  }

  onDealerChange = async (data: any) => {
    await this.promisedSetState({
      dealerCode: data.value,
      dealerSelected: [data.value],
      driverCode: null,
      driverName: null,
    });
  };

  onStringFieldChange = <T extends keyof Pick<any, "engineNumber" | "documentType" | "documentNumber">>(target: T, value: any) => {
    const currentState: any = { ...this.state };

    switch (target) {
      case "engineNumber":
        currentState.engineNumber = value;
        break;
      case "documentType":
        currentState.documentType = value;
        break;
      case "documentNumber":
        currentState.documentNumber = value;
        break;
    }

    this.setState({
      ...currentState,
    });
  };

  beforeUploadFile = (file: any) => {
    const isImage = file.type.startsWith("image/");
    console.log(isImage);

    if (!isImage) {
      Modal.error({
        title: "update Failed",
        content: "mohon upload file dengan tipe image ",
      });
    }
    this.setState({
      documentFile: file,
    });
    return false;
  };

  onReset = async () => {
    await this.promisedSetState({
      ...this.initState,
    });
  };

  onHandoverDocument = async () => {
    const currentState: any = { ...this.state };

    if (!currentState.dealerCode) {
      Modal.error({ title: "Error", content: "Invalid Dealer" });
      return;
    }
    if (!currentState.engineNumber) {
      Modal.error({ title: "Error", content: "Invalid Nomor Mesin" });
      return;
    }
    if (!currentState.documentType) {
      Modal.error({ title: "Error", content: "Invalid Tipe Dokumen" });
      return;
    }
    if (!currentState.documentNumber) {
      Modal.error({ title: "Error", content: "Invalid Nomor Dokumen" });
      return;
    }

    this.setState({ submitting: true });

    const formData = new FormData();
    formData.append("vehicle_engine_number", currentState.engineNumber);
    formData.append("document_type", currentState.documentType);
    formData.append("document_number", currentState.documentNumber);
    formData.append("document_image", currentState.documentFile);
    formData.append("updated_by", this.user);

    try {
      // docUploadApiService.setToken(this.token);
      await docUploadApiService.uploadDocumentHadover(formData).then((result) => {
        Modal.success({
          title: "Proses Sukses",
          content: result?.data?.message,
        });

        this.onReset();
      });
    } catch (e: any) {
      Modal.error({
        title: "Proses Gagal",
        content: "Server Menolak Inputan Anda :" + e.message,
      });
      await this.promisedSetState({
        submitting: false,
      });
    }
  };

  promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

  render() {
    return (
      <React.Fragment>
        <MainLayout onChangeDealer={this.onDealerChange} breadcrumbPath={`Dokumen`} breadcrumbMenu={`Dokumen Handover`} defaultSelectedKeys={["m-document-handover"]} defaultOpenKeys={["sm-document"]}>
          <Form layout={"vertical"}>
            <Row>
              <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 18 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ padding: 5 }}>
                <Row>
                  <Col xl={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        Nomor Mesin <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <Input type="text" value={this.state.engineNumber} placeholder="Nomor Mesin" onChange={(event) => this.onStringFieldChange("engineNumber", event.target.value)} />
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        Tipe Dokumen <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <Select
                        placeholder="Tipe Dokumen"
                        style={{ fontSize: "85%", minWidth: "200px" }}
                        value={this.state.documentType}
                        onChange={(event) => this.onStringFieldChange("documentType", event)}
                      >
                        <Select.Option value="pelat">PELAT</Select.Option>
                        <Select.Option value="notice">NOTICE</Select.Option>
                        <Select.Option value="stnk">STNK</Select.Option>
                        <Select.Option value="bpkb">BPKB</Select.Option>
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                    <Form.Item style={{ paddingRight: 10 }}>
                      <i className={`text-small-grey-nopadding`}>
                        Nomor Dokumen <span style={{ color: "red" }}>*</span>{" "}
                      </i>
                      <Input type="text" value={this.state.documentNumber} placeholder="Nomor Dokumen" onChange={(event) => this.onStringFieldChange("documentNumber", event.target.value)} />
                    </Form.Item>
                  </Col>
                  <br />{" "}
                  <Col xl={{ span: 24 }} lg={{ span: 24 }} md={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ paddingRight: 10 }}>
                    {/* <Upload name="image" listType="picture" maxCount={1} beforeUpload={this.beforeUploadFile} style={{ width: "100%", height: 200 }} showUploadList={false} /> */}
                    <Form.Item label="Upload Gambar Dokumen" className="col-lg-12 mb-2">
                      <Upload maxCount={1} listType="picture" beforeUpload={this.beforeUploadFile} accept="image/*">
                        <Button icon={<UploadOutlined />} loading={this.state.processing}>
                          Upload Gambar Dokumen
                        </Button>
                      </Upload>
                    </Form.Item>
                  </Col>
                </Row>
              </Col>
            </Row>

            <Row>
              <Col xl={{ span: 6 }} lg={{ span: 8 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }}>
                <Row>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ padding: 5 }}>
                    <Button type={"primary"} icon={<SaveOutlined />} loading={this.state.submitting} onClick={this.onHandoverDocument} style={{ width: "100%" }}>
                      Simpan Data
                    </Button>
                  </Col>
                  <Col xl={{ span: 12 }} lg={{ span: 12 }} md={{ span: 12 }} sm={{ span: 24 }} xs={{ span: 24 }} style={{ padding: 5 }}>
                    <Button type={"primary"} danger icon={<UndoOutlined />} onClick={this.onReset} loading={this.state.submitting} style={{ width: "100%" }}>
                      Reset Form
                    </Button>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Form>
        </MainLayout>
      </React.Fragment>
    );
  }
}

export default withAuth(withRouter(DocumentHandover), 56);
